import { ReactNode, useCallback, useEffect, useState } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import useCollapsable, { CollapsableContext } from "@components/Collapsable/useCollapsable";

const CollapsableRoot: FCX<{
    defaultShow?: boolean;
}> = ({
    className,
    children,
    testId,
    defaultShow = false,
    ...props
}) => {
    const [show, setShow] = useState(defaultShow);
    const toggle = useCallback(() => setShow(prev => !prev), []);

    useEffect(() => {
        setShow(defaultShow);
    }, [defaultShow]);

    return (
        <CollapsableContext.Provider value={{ show, toggle }}>
            {children}
        </CollapsableContext.Provider>
    );
};

const Control: FCX<{
    renderLabel: (show: boolean) => ReactNode;
}> = ({
    className,
    renderLabel,
    testId,
    ...props
}) => {
    const { show, toggle } = useCollapsable();

    return (
        <div
            className={cn("Collapsable__control", className)}
            data-testid={testId ?? "blockCollapsableControl"}
            onClick={toggle}
            {...props}
        >
            {renderLabel(show)}
        </div>
    );
};

const Content: FCX = ({
    className,
    children,
    testId,
    ...props
}) => {
    const { show } = useCollapsable();

    return (
        <div
            className={cn(
                "Collapsable__content",
                !show && 'is-collapsed',
                className,
            )}
            data-testid={testId ?? "blockCollapsableContent"}
            {...props}
        >
            {children}
        </div>
    );
};

const Collapsable = Object.assign(CollapsableRoot, {
    Control,
    Content,
});

export default Collapsable;
